export default "__VITE_ASSET__DUAUfzBA__"